<template>
	<div @click="refocus" class="tag-input">
		<span v-for="(tag, index) in tags" :key="index" class="tag-input__tag">
				<span>{{ tag }}</span>
				<a v-on:click="remove(index)" class="tag-input__remove"></a>
			</span>
		<input type="text" v-model="newTag" ref="input"
			:placeholder="placeholder"
			v-on:keypress="keypress"
			v-on:keydown="keydown"
			v-on:blur="keydown"
			v-on:keydown.delete="keydownDelete"
			:maxlength="tagMaxLength"
			class="tag-input__input" />
	</div>
</template>
<script>
	export default {
		name: 'TagInput',
		props: {
			tags: {
				type: Array,
				default: function () { return []; }
			},
			placeholder: {
				type: String,
				default: ''
			}
		},
		data: function () {
			return {
				newTag: '',
				tagMaxLength: Grabcad.AttributeLimits.Generic.TAG
			};
		},
		computed: {
			splitTags: function () {
				return this.newTag.split(/[\s,;]+/).filter(Boolean);
			}
		},
		methods: {
			refocus: function () {
				this.$refs.input.focus();
			},
			remove: function (index) {
				this.tags.splice(index, 1);
			},
			keydownDelete: function () {
				if (this.newTag) { return }
				this.tags.pop();
			},

			keypress: function (event) {
				if ([',', ';'].includes(String.fromCharCode(event.which))) {
					this.handleKeyEvents(event);
				}
			},

			keydown: function (event) {
				if (event.type === 'blur' || ['Enter', 'Tab'].includes(event.code)) {
					this.handleKeyEvents(event);
				}
			},

			handleKeyEvents: function (event) {
				if (this.newTag) {
					event.preventDefault();
					this.splitTags.forEach((item) => this.tags.push(item));

					this.newTag = ''
				}
			}
		}
	}
</script>
